import React from 'react'
import HelpPageForm, { FormMode } from '../components/HelpPageForm'
import { useTranslation } from 'react-i18next'

const ViewHelpPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HelpPageForm title={t('HelpPage:form.label.viewVersion')} mode={FormMode.view} />
    </>
  )
}

export default ViewHelpPage
